module.exports = __webpack_public_path__ + "media/images/tl/banner/id-light-pc-e53fe77068bcba54d6f8a3b9ab45ede1.jpg";